import { Loader } from '@/components/custom-components/Loader'
import OnboardingHeader from '@/components/onboarding/OnboardingHeader.tsx'
import { trpc } from '@/utils/trpc.ts'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useLocalStorage } from 'usehooks-ts'

type IntentType = 'sign-in' | 'sign-up'

type SearchParams = {
  intent?: IntentType
}

export const Route = createFileRoute('/auth-success')({
  component: AuthSuccess,
  validateSearch: (search: Record<string, unknown>): SearchParams => {
    const intent = search?.intent as IntentType

    return {
      intent,
    }
  },
})

function AuthSuccess() {
  const { intent } = Route.useSearch()
  const navigate = useNavigate()

  const { data: authUser, isLoading } = trpc.me.useQuery(null)
  const [, set_wos_user] = useLocalStorage<
    | {
        object: 'user'
        email: string
        id: string
        createdAt: string
        avatar: string | null
        updatedAt: string
        firstName: string | null
        lastName: string | null
        userHash: string
        emailVerified: boolean
        profilePictureUrl: string | null
        subscribed?: boolean | null
      }
    | undefined
  >('_wos_user', authUser)

  useEffect(() => {
    if (authUser) {
      set_wos_user(authUser)

      setTimeout(() => {
        if (intent && intent === 'sign-up') {
          navigate({
            to: '/checkout',
          })
        } else {
          navigate({
            to: '/feeds/templates',
            search: {
              orderFilter: 'Recent',
              cacheBuster: Math.random(),
            },
          })
        }
      }, 500)
    }
  }, [isLoading])

  if (isLoading) {
    return (
      <div className="flex justify-center items-center w-full h-screen">
        <Loader />
      </div>
    )
  }

  return (
    <div className={'bg-brandgrad bg-no-repeat bg-center bg-cover min-h-screen'}>
      <div>
        <OnboardingHeader />
      </div>
      <div className={'flex-1 flex flex-col justify-center items-center py-[7.75rem]'}></div>
    </div>
  )
}
